// Two helpers that every "REST seed + live overlay" list in this dashboard needs.
//
// They used to live inside the Activity view, which is where the audit feed and
// the call log happened to be. UX3/UX4 moved those two lists into Logs and the
// usage ledger into Audit, so the helpers moved HERE rather than being copied
// into each — a merge rule that drifts between two lists is a bug nobody sees.

/** Merge a live list over a REST seed by id (live wins), newest `ts` first. */
export function mergeById<T>(live: T[], seed: T[], id: (x: T) => string): T[] {
  const map = new Map<string, T>();
  for (const s of seed) map.set(id(s), s);
  for (const l of live) map.set(id(l), l); // live wins
  return [...map.values()].sort((a, b) => tsOf(b) - tsOf(a));
}

function tsOf<T>(x: T): number {
  const ts = (x as unknown as { ts?: string }).ts;
  const t = ts ? new Date(ts).getTime() : 0;
  return Number.isNaN(t) ? 0 : t;
}

/** A timestamp as the local machine reads it; an unparseable one is shown verbatim. */
export function fmt(ts: string): string {
  const d = new Date(ts);
  return Number.isNaN(d.getTime()) ? ts : d.toLocaleString();
}
